import { Moon, Sun } from "lucide-react";
import { useApp } from "@/context/AppContext";

export function ThemeToggle({ testid = "theme-toggle" }) {
  const { theme, toggleTheme } = useApp();
  const dark = theme === "dark";
  return (
    <button onClick={toggleTheme} data-testid={testid} title={dark ? "Parlak moda geç" : "Koyu moda geç"} aria-label={dark ? "Parlak mod" : "Koyu mod"}
      className="h-9 w-9 rounded-lg flex items-center justify-center hover:bg-secondary text-muted-foreground hover:text-foreground transition-colors">
      {dark ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
